import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { Modal, Button, Box } from '@mantine/core';
import { useContent } from '@/providers/ContentProvider';

const baseSlug = 'instructions.';

export const InstructionModal: FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	const { options } = useTypedSelector((state) => state.creator);

	const handleClose = () => {
		dispatch(creatorActions.updateOptions({ instructionModalOpened: false }));
	};

	return (
		<Modal
			opened={options.instructionModalOpened}
			onClose={handleClose}
			title="Jak działa nasz konfigurator?"
			size="xl"
		>
			<Box c="dimmed" mb="lg">
				{getContent(`${baseSlug}content`)}
			</Box>
			<Button onClick={handleClose} mx="auto" color="black" size="md">
				Przejdź do konfiguratora
			</Button>
		</Modal>
	);
};
